/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { Route, RouteComponentProps, useHistory } from 'react-router-dom';
import { getModuleNameFromPath, isModuleActive } from '../views/LogisticServices/utils/general.utils';
import { getNudosData } from '../utils/getNudosData';

export const PrivateRoute = ({
  component,
  path
}: {
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  path?: string;
}) => {
  const { replace } = useHistory();

  const hasAuthorization = () => {
    if (process.env.NODE_ENV === 'development') return true;
    const moduleName = getModuleNameFromPath(path || '');
    return isModuleActive(moduleName);
  };

  useEffect(() => {
    const user = getNudosData();
    if (!user?.userData?.id) replace('/auth/login');

    const isAuthorizedForThisModule = hasAuthorization();
    if (!isAuthorizedForThisModule) replace('/unauthorized');
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps

  return <Route {...{ component, path }} />;
};

export const PublicRoute = ({
  component,
  path
}: {
  component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  path?: string;
}) => {
  const { replace } = useHistory();

  const _user = localStorage.getItem('_userInfo');
  if (_user) replace('/catalog/product-list');
  return <Route {...{ component, path }} />;
};
